export const getComponent = (type: string) => {
    switch (type) {
        case 'input':
            return 'smart-input'
        case 'input-tag':
            return 'smart-input-tag'
        case 'number':
            return 'a-input-number'
        case 'password':
            return 'smart-password'
        case 'icon-picker':
            return 'smart-icon-picker'
        case 'range-picker':
            return 'smart-range-picker'
        case 'select':
            return 'smart-select'
        case 'radio':
            return 'a-radio-group'
        case 'radio-button':
            return 'smart-radio-button'
        default:
            if (/^smart/.test(type)) {
                return type
            }
            if (type) {
                return `a-${type}`
            }
            return 'a-input'
    }
}

export const moneyFormat = (val) => {
    if (isNaN(val)) {
        return '-'
    } else {
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
}
